// extracted by mini-css-extract-plugin
module.exports = {"titleWrap":"Title_titleWrap__2ZVlU","iconWrap":"Title_iconWrap__GXNG4","title":"Title_title__1YpvT","subtitle":"Title_subtitle__1lshI","icon":"Title_icon__2bBg6"};